import React from 'react';

import { CodeBlockType } from '../../../types';

import { Multi } from './Multi';
import { Simple } from './Simple';

interface Props {
  type: CodeBlockType;
  title?: string;
  label?: string;
  className: string;
}

export const CodeBlock: React.FC<Props> = ({
  type = CodeBlockType.Simple,
  title,
  label,
  className,
  children,
}) => {
  if (type === CodeBlockType.Simple) {
    return (
      <Simple title={title} label={label} className={className}>
        {children}
      </Simple>
    );
  }

  if (type === CodeBlockType.Multi) {
    return <Multi className={className}>{children}</Multi>;
  }

  return null;
};
